import { globalSearchConstants as gs } from 'srcReact/SearchPage'
import { isNative } from 'srcReact/helpers/utils'
import { appConstantSettings } from 'srcReact/appConstantSettings'

// nativeapp
const urlParams = new URLSearchParams(window.location.search)
const getNativeSearchText =
  urlParams.get('clear_search') == 1 ? localStorage.removeItem('search_text') : localStorage.getItem('search_text')
const searchText = isNative() ? getNativeSearchText || '' : urlParams.get('text') || ''
const searchSuggestionList = JSON.parse(localStorage.getItem('search_suggestion_list')) || []

const initialState = {
  loading: false,
  loaded: false,
  filterItem: 'all',
  searchText: searchText,
  searchInterestText: searchText,
  searchSuggestionList: searchSuggestionList,
  searchSelectedMember: null,
  filters: {
    total_all: 0,
    total_groups: 0,
    total_mixrs: 0,
    total_members: 0,
    total_media: 0,
    total_posts: 0,
    total_my_groups: 0,
    total_my_mixrs: 0,
    nextOffset: 0,
    remaining: 0
  },
  stat: {
    total: 0,
    nextOffset: 0,
    remaining: 0
  },
  mixrs: [],
  groups: [],
  members: [],
  media: [],
  media_posts: {
    newsfeeds: [],
    users: [],
    results: []
  },
  posts: {
    newsfeeds: [],
    users: [],
    results: []
  },
  results: []
}

export function globalSearch(state = initialState, action) {
  let searchSuggestionList = [...state.searchSuggestionList]

  switch (action.type) {
    case gs.SET_FILTER_ITEM:
      return {
        ...state,
        filterItem: action.filterItem
      }
    case gs.SET_SEARCH_SELECTED_MEMBER:
      return {
        ...state,
        searchSelectedMember: action.searchSelectedMember
      }
    case gs.SET_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.searchText
      }
    case gs.GET_GLOBAL_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false
      }
    case gs.GET_GLOBAL_SEARCH_SUCCESS:
      let searchInterestText = state.searchText
      if (state.searchText.length >= appConstantSettings.SEARCH_LENGTH) {
        searchSuggestionList = [state.searchText, ...state.searchSuggestionList]
        localStorage.setItem('search_suggestion_list', JSON.stringify(searchSuggestionList))
      }
      localStorage.setItem('search_text', searchSuggestionList[0])
      return {
        ...state,
        ...action.data,
        searchInterestText,
        mixrs: action.data.mixrs || [],
        groups: action.data.groups || [],
        members: action.data.members || [],
        media: action.data.media || [],
        media_posts: {
          ...state.media_posts,
          ...action.data.media_posts
        },
        posts: {
          ...state.posts,
          ...action.data.posts
        },
        results: action.data.results || [],
        searchSuggestionList: searchSuggestionList,
        loading: false,
        loaded: true
      }
    case gs.GET_GLOBAL_SEARCH_FAILURE:
      if ((action.error && action.error.message) === 'cancelTokenError') {
        return {
          ...state,
          loading: true,
          loaded: false
        }
      }
      if (state.searchText.length >= appConstantSettings.SEARCH_LENGTH) {
        searchSuggestionList = [state.searchText, ...state.searchSuggestionList]
        localStorage.setItem('search_suggestion_list', JSON.stringify(searchSuggestionList))
      }
      localStorage.setItem('search_text', searchSuggestionList[0])
      return {
        ...state,
        ...initialState,
        filterItem: state.filterItem,
        searchText: state.searchText,
        searchSuggestionList: searchSuggestionList,
        searchSelectedMember: state.searchSelectedMember,
        loading: false,
        loaded: true
      }
    case gs.GET_GLOBAL_SEARCH_PAGINATION_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: true
      }
    case gs.GET_GLOBAL_SEARCH_PAGINATION_SUCCESS:
      const { mixrs, groups, members, media, media_posts, posts, results } = action.data
      let nextSearchMixrs = [...state.mixrs]
      let nextSearchGroups = [...state.groups]
      let nextSearchMembers = [...state.members]
      let nextSearchMedia = [...state.media]
      let nextSearchMediaPosts = {
        ...state.media_posts
      }
      let nextSearchPosts = {
        ...state.posts
      }
      let nextSearchResults = [...state.results]
      if (mixrs) {
        const nextSearchMixrsIds = new Set(mixrs.map((m) => m.id))
        nextSearchMixrs = [...state.mixrs?.filter((m) => !nextSearchMixrsIds.has(m.id)), ...mixrs]
      }
      if (groups) {
        const nextSearchGroupsIds = new Set(groups.map((g) => g.id))
        nextSearchGroups = [...state.groups?.filter((g) => !nextSearchGroupsIds.has(g.id)), ...groups]
      }
      if (members) {
        const nextSearchMembersIds = new Set(members.map((m) => m.id))
        nextSearchMembers = [...state.members?.filter((m) => !nextSearchMembersIds.has(m.id)), ...members]
      }
      if (media) {
        const nextSearchMediaIds = new Set(media.map((m) => m.id))
        nextSearchMedia = [...state.media?.filter((m) => !nextSearchMediaIds.has(m.id)), ...media]
      }
      if (media_posts) {
        const nextSearchNewsfeedsIds = new Set(media_posts.newsfeeds.map((p) => p.id))
        const nextSearchUsersIds = new Set(media_posts.users.map((p) => p.id))
        const nextSearchPostsIds = new Set(media_posts.results.map((p) => p.id))
        nextSearchMediaPosts = {
          ...state.media_posts,
          newsfeeds: [
            ...state.media_posts.newsfeeds?.filter((n) => !nextSearchNewsfeedsIds.has(n.id)),
            ...media_posts.newsfeeds
          ],
          users: [...state.media_posts.users?.filter((u) => !nextSearchUsersIds.has(u.id)), ...media_posts.users],
          results: [...state.media_posts.results?.filter((p) => !nextSearchPostsIds.has(p.id)), ...media_posts.results]
        }
      }
      if (posts) {
        const nextSearchNewsfeedsIds = new Set(posts.newsfeeds.map((p) => p.id))
        const nextSearchUsersIds = new Set(posts.users.map((p) => p.id))
        const nextSearchPostsIds = new Set(posts.results.map((p) => p.id))
        nextSearchPosts = {
          ...state.posts,
          newsfeeds: [...state.posts.newsfeeds?.filter((n) => !nextSearchNewsfeedsIds.has(n.id)), ...posts.newsfeeds],
          users: [...state.posts.users?.filter((u) => !nextSearchUsersIds.has(u.id)), ...posts.users],
          results: [...state.posts.results?.filter((p) => !nextSearchPostsIds.has(p.id)), ...posts.results]
        }
      }
      if (results) {
        const nextSearchResultIds = new Set(results.map((r) => r.id))
        nextSearchResults = [...state.results?.filter((r) => !nextSearchResultIds.has(r.id)), ...results]
      }
      return {
        ...state,
        ...action.data,
        mixrs: nextSearchMixrs,
        groups: nextSearchGroups,
        members: nextSearchMembers,
        media: nextSearchMedia,
        media_posts: nextSearchMediaPosts,
        posts: nextSearchPosts,
        results: nextSearchResults,
        loading: false,
        loaded: true
      }
    case gs.GET_GLOBAL_SEARCH_PAGINATION_FAILURE:
      return { ...state, loading: false, loaded: true }
    default:
      return state
  }
}
